import { createFileRoute, redirect } from '@tanstack/react-router'
import { webhookSecretsQuery, webhooksQuery } from '../../../../data/webhooks.tsx'
import { WebhookSecretForm } from '../../../../features/serviceManagement/webhooks/WebhookSecretForm.tsx'

export const Route = createFileRoute('/_app/smp/webhooks/$webhookId/secrets/$secretId/edit')({
	component: RouteComponent,
	loader: async (ctx) => {
		const [webhooks, secrets] = await Promise.all([
			ctx.context.queryClient.ensureQueryData(webhooksQuery(ctx.context.impersonation)),
			ctx.context.queryClient.ensureQueryData(webhookSecretsQuery(ctx.params.webhookId)),
		])
		const webhook = webhooks.find((wh) => wh.id === ctx.params.webhookId)
		if (!webhook) throw redirect({ to: '/smp/webhooks/{-$webhookId}', params: { webhookId: undefined } })

		const secret = secrets.find((whsec) => whsec.id === ctx.params.secretId)
		if (!secret) throw redirect({ to: '/smp/webhooks/$webhookId/secrets/create', params: { webhookId: ctx.params.webhookId } })

		return { webhook, secret }
	},
})

function RouteComponent() {
	const { webhook, secret } = Route.useLoaderData()
	return <WebhookSecretForm webhook={webhook} secret={secret} />
}
